import {
  createEffect,
  createSignal,
  JSXElement,
  mergeProps,
  Show
} from 'solid-js';
import { HttpStatusCode } from 'axios';
import { AppErrors } from '~/components/ErrorBoundaries/utils.ts';
import Request from '~/api/Request.ts';
import { setGlobalStore } from '~/stores';
import { clearAgentPortalAuthSession } from '~/utils/agentPortalAuthStorage.ts';

type AgentPortalApiConnectorProps = {
  children: JSXElement;
};

export default function AgentPortalApiConnector(
  props: AgentPortalApiConnectorProps
): JSXElement {
  const merged = mergeProps({}, props);
  const [errorCode, setErrorCode] = createSignal<AppErrors | null>(null);

  createEffect(() => {
    if (errorCode() === AppErrors.AGENT_PORTAL_SESSION_EXPIRED) {
      throw new Error(AppErrors.AGENT_PORTAL_SESSION_EXPIRED);
    }
  });

  new Request({
    onResponseError: (error) => {
      // Handle unauthorized responses
      // and throw propagate to error boundary
      if (error?.status === HttpStatusCode.Unauthorized) {
        clearAgentPortalAuthSession();
        setGlobalStore('agentPortalAuthToken', null);
        setGlobalStore('agentPortalSessionExpiry', null);
        setErrorCode(AppErrors.AGENT_PORTAL_SESSION_EXPIRED);
      }
      return Promise.reject(error);
    }
  });
  return <Show when={!errorCode()}>{merged.children}</Show>;
}
